import { BaseModel } from "../base.model";

export class Question extends BaseModel {

  public id: number;
  public sectionId?: number;
  public title: string;
  public answer: string;

  constructor() {
    super();
    this.sectionId = null;
  }
}
